module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Pénznem","track":"Currency"}}